import { render, staticRenderFns } from "./dealRecord.vue?vue&type=template&id=279c2b75&scoped=true&"
import script from "./dealRecord.vue?vue&type=script&lang=js&"
export * from "./dealRecord.vue?vue&type=script&lang=js&"
import style0 from "./dealRecord.vue?vue&type=style&index=0&id=279c2b75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279c2b75",
  null
  
)

export default component.exports